import { Fragment, type FC } from 'react';
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { Delete, FileDownload, MoreVert } from '@mui/icons-material';

export type AuditDetailsPageMenuProps = {
  onClose: () => void;
  onOpen: (event: HTMLElement) => void;

  isOpen: boolean;
  anchorEl: HTMLElement | null;

  onExport: () => void;
  onDelete: () => void;

  isExportPending?: boolean;
};

export const AuditDetailsPageMenu: FC<AuditDetailsPageMenuProps> = ({
  onClose,
  onOpen,

  isOpen,
  anchorEl,

  onExport,
  onDelete,

  isExportPending = false,
}) => (
  <Fragment>
    <IconButton
      color="inherit"
      aria-label="more"
      aria-controls={isOpen ? 'Audit menu' : undefined}
      aria-expanded={isOpen ? 'true' : undefined}
      aria-haspopup="true"
      onClick={(e) => onOpen(e.currentTarget)}>
      <MoreVert />
    </IconButton>
    <Menu anchorEl={anchorEl} open={isOpen} onClose={onClose}>
      <MenuItem onClick={onExport} disabled={isExportPending}>
        <ListItemIcon>
          <FileDownload />
        </ListItemIcon>
        <ListItemText>
          {isExportPending ? 'Exporting…' : 'Export'}
        </ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={onDelete}>
        <ListItemIcon>
          <Delete />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  </Fragment>
);
